<template>
    <div id="activity">
        <div>
            <el-card>
                <el-form ref="form" :model="form" label-width="80px" :inline="true" size="small">
                    <el-form-item>
                        <el-button type="primary" size="small" @click="addRecharge">添加设置</el-button>
                    </el-form-item>
                </el-form>
                <el-table
                        :data="tableData"
                        border
                        style="width: 100%">
                    <el-table-column
                            prop="title"
                            label="活动名称">
                    </el-table-column>
                    <el-table-column
                            prop="anid"
                            label="书籍id">
                    </el-table-column>
                     <el-table-column
                            prop="pay_id"
                            label="支付id">
                    </el-table-column>
                    <el-table-column
                            prop="url"
                            label="封面"
                            width="122">
                        <template slot-scope="scope">
                            <img :src="scope.row.url" width="30" height="30" alt="">
                        </template>
                    </el-table-column>
                     <el-table-column
                            label="状态">
                        <template slot-scope="scope">
                            <span v-if="scope.row.status==0">APP不显示</span>
                            <span v-if="scope.row.status==1">APP显示</span>
                        </template>
                    </el-table-column>       
                    <el-table-column
                            label="类型">
                              <template slot-scope="scope">
                                <span v-if="scope.row.type==1">弹框：支付活动</span>
                                <span v-if="scope.row.type==2">弹框：新书推荐</span>
                                <span v-if="scope.row.type==3">弹框：VIP活动</span>
                                <span v-if="scope.row.type==4">弹框：链接活动</span>

                                 <span v-if="scope.row.type==5">书架：支付活动</span>
                                <span v-if="scope.row.type==6">书架：新书推荐</span>
                                <span v-if="scope.row.type==7">书架：VIP活动</span>
                                <span v-if="scope.row.type==8">书架：链接活动</span>

                                 <span v-if="scope.row.type==9">福利中心：支付活动</span>
                                <span v-if="scope.row.type==10">福利中心：新书推荐</span>
                                <span v-if="scope.row.type==11">福利中心：VIP活动</span>
                                <span v-if="scope.row.type==12">福利中心：链接活动</span>

                                <span v-if="scope.row.type==13">详情页：支付活动</span>
                                <span v-if="scope.row.type==14">详情页：新书推荐</span>
                                <span v-if="scope.row.type==15">详情页：VIP活动</span>
                                <span v-if="scope.row.type==16">详情页：链接活动</span>

                                <span v-if="scope.row.type==17">支付页：支付活动</span>
                                <span v-if="scope.row.type==18">支付页：新书推荐</span>
                                <span v-if="scope.row.type==19">支付页：VIP活动</span>
                                <span v-if="scope.row.type==20">支付页：链接活动</span>
                        </template>
                    </el-table-column>
                      <el-table-column
                            prop="http_url"
                            label="外部链接">
                    </el-table-column>
                    
                    <el-table-column
                            width="150"
                            label="操作">
                        <template slot-scope="scope">
                            <el-button type="warning" plain size="small" @click="edit(scope.row.id)">修改</el-button>
                            <el-button type="danger" plain size="small" @click="remove(scope.row.id)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-card>
            <!--            新增或编辑-->
            <el-dialog :title="fromTitle" width="50%" :visible.sync="visible">
                <el-row :gutter="20">
                    <el-col :span="15">
                        <el-form ref="form" label-width="150px" size="small">
                            <el-form-item label="名称">
                                <el-input v-model="form.title"></el-input>
                            </el-form-item>

                            <el-form-item label="书籍ID">
                                <el-input v-model="form.anid"></el-input>
                            </el-form-item >

                             <el-form-item label="支付ID">
                                <el-input v-model="form.pay_id"></el-input>
                            </el-form-item >

                            <el-form-item label="活动封面">
                                <el-upload
                                        class="avatar-uploader"
                                        action="upDataUrl"
                                        :show-file-list="false"
                                        :http-request="myUpload1"
                                        :before-upload="beforeAvatarUpload">
                                    <img v-if="form.url" :src="form.url" class="avatar">
                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                </el-upload>
                            </el-form-item>

                             <el-form-item label="外部链接">
                                <el-input v-model="form.http_url"></el-input>
                            </el-form-item>

                            <el-form-item label="类型">
                                <el-input v-model="form.type" maxlength="3"></el-input>
                                <span class="input_hint">严格遵循以下配置：</span>
                            </el-form-item>
                            <div style="line-height: 24px;margin-left: 150px;width: 100%;font-size: 12px;margin-bottom: 30px;color: red;" >
                                <p>弹框运营位： （1弹框支付活动 2弹框新书推荐 3弹框VIP活动 4弹框URL活动） </p>
                                <p>书架运营位： （5书架支付活动 6书架新书推荐 7书架VIP活动 8书架URL活动） </p>
                                <p>福利中心运营位： （9福利支付活动 10福利新书推荐 11福利VIP活动 12福利URL活动） </p>
                                <p>书籍详情页运营位： （13详情页支付活动 14详情页新书推荐 15详情页VIP活动 16详情页URL活动） </p>
                                 <p>支付页运营位： （17支付活动 18新书推荐 19VIP活动 20URL活动） </p>
                            </div>

                            <el-form-item label="状态">
                                <el-input v-model="form.status" maxlength="1"></el-input>
                                <span class="input_hint">0:不显示,1:显示</span>
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>
                <span slot="footer" class="dialog-footer">
                <el-button @click="dialogClose" size="small">取 消</el-button>
                <el-button type="primary" @click="dialogAffirm" size="small">确 定</el-button></span>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import {uploadimg} from "../../utils/common";
export default {
    name: "activity",
    data(){
        return {
            props:{muliple:true},
            form:{
                title: '',
                anid:'',
                pay_id:'',
                url:'',
                http_url:'',
                type:'',
                status:'',        
            },
            tableData:[],
            visible:false,
            fromTitle:'',
            id: '',
        }
    },
    created() {
        this.getData()
    },
    methods:{
        getData() {
            this.$axios.post('admin/activity/index', {}).then((res) => {
                let obj = res.data;
                let arr = [];
                for (let key in obj) {
                    arr.push(obj[key])
                }
                this.tableData = arr;
            });
        },
        dialogClose() {
            this.visible = false
        },
        addRecharge() {
            this.form = {
                title: '',
                anid:'',
                pay_id:'',
                url:'',
                http_url:'',
                type:'',
                status:'',
            };
            this.id = '';
            this.fromTitle = '新增';
            this.visible = true
        },
        edit(id){
            this.fromTitle = '修改';
            this.id = id;
            this.$axios.get('admin/activity/' + this.id, '').then((res) => {
                this.visible = true;
                this.form = res.data;
            });
        },
            dialogAffirm() {
            if (this.id) {
                // 编辑
                this.$axios.put('admin/activity/' + this.id, this.form).then((res) => {
                    this.$message.success('成功');
                    this.getData();
                    this.visible = false
                });
            } else {
                // 添加
                this.$axios.post('admin/activity', this.form).then((res) => {
                    this.$message.success('成功');
                    this.getData();
                    this.visible = false
                });
            }
        },
        remove(id){
            this.$confirm('确定要进行操作, 是否继续?','提示',{
                    confirmButtonText:'确定',
                    cancelButtonText:'取消',
                    type: 'warning'
            }).then(() =>{
                    this.$axios.del('admin/activity/' + id, '').then((res)=>{
                        this.$message.success('删除成功!');
                        this.getData();
                    });
            }).catch(() => {

            });
        },
            // 上传图片文件
        myUpload1(content) {
            uploadimg(content).then(res => {
                this.form.url = res;
            });
        },
        beforeAvatarUpload(file) {
            var suffix = file.name.substring(file.name.lastIndexOf('.') + 1);
            let arr = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'pdf', 'JPG', 'JPEG', 'PNG', 'GIF', 'BMP', 'PDF']
            if (arr.indexOf(suffix) === -1) {
                this.$message.error('上传图片格式有误');
                return false
            }
        },
        html_decode(str) {
            var s = "";
            if (str.length == 0) return "";
            s = str.replace(/&amp;/g, "&");
            s = s.replace(/&lt;/g, "<");
            s = s.replace(/&gt;/g, ">");
            s = s.replace(/&nbsp;/g, " ");
            s = s.replace(/&#39;/g, "\'");
            s = s.replace(/&quot;/g, "\"");
            s = s.replace(/<br\/>/g, "\n");
            return s;
        }
    }
}
</script>